import UsersList from './UsersList';

export default UsersList;


// WEBPACK FOOTER //
// ./resources/assets/js/components/UsersList/index.js